import template from './test_translate_page.html';
import tr from '../lib/default-translator.js';

class TestTranslateViewModel {
	constructor(page) {
		this.page = page;
	}
}

class TestTranslatePage {
	constructor(bindings) {
		this.bindings = bindings;
		this.viewModel = new TestTranslateViewModel(this);
	}

	init() {
		document.title = tr('Test Translate');
	}
}

export default {
	route: '[/]test_translate',
	page_class: TestTranslatePage,
	template: template,
	template_filename: 'translation/test_translate_page'
};
